import { render } from "./MonthAndYear.vue?vue&type=template&id=75d1d562&ts=true"
import script from "./MonthAndYear.vue?vue&type=script&lang=ts"
export * from "./MonthAndYear.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__